/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".vcenter[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle;float:none}\n/*# sourceMappingURL=header-logos.component.css.map*/"];
export { styles as styles };
